import Vue from "vue";
import "./plugins/fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase";
import Buefy from "buefy";
import { config } from "./helpers/firebaseConfig";
import VuejsDialog from "vuejs-dialog";
import "./registerServiceWorker";

Vue.use(Buefy);
Vue.use(require("vue-moment"));
Vue.use(VuejsDialog);
Vue.config.productionTip = false;

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    this.router.push("/home");
  } else {
    this.router.push("/login");
  }
});

export const db = firebase.firestore();

new Vue({
  router,
  store,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
